import React, { useContext, useState } from "react";
import { TextField, Button, Alert, CircularProgress } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import "./LoginForm.css"; // Reuse similar styling
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import WhiteInputField from '../../common/StyledComponents/WhiteInputField/WhiteInputField';
import StyledTextField from '../../common/StyledComponents/StyledTextField';

const LoginForm = ({ setCurrentStep }) => {
  const [formData, setFormData] = useState({
    identifier: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const [forgotPassword, setForgotPassword] = useState(false); // Toggle forgot password
  const [resetEmail, setResetEmail] = useState(""); // Email for password reset
  const axiosInstance = useAxios();
  const { setToken, setRole, setStatus } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleForgotPassword = async () => {
    setError(null);
    setLoading(true); // Enable loading state
    try {
      const response = await axiosInstance.post("/request-password-reset", {
        email: resetEmail,
      });
      setToken(response.data.token);
      if (response.data.role === "student") {
        setCurrentStep("passwordOtp"); // OTP-only step for students
      } else {
        setCurrentStep("reset-password"); // Full reset for other roles
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to request password reset.");
    } finally {
      setLoading(false); // Disable loading state
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Enable loading state

    try {
      const response = await axiosInstance.post("/login", formData);
      console.log(response.data);
      setToken(response.data.token);
      setRole(response.data.role);
      setStatus(response.data.status);
      navigate('/'); //
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Invalid credentials.");
    } finally {
      setLoading(false); // Disable loading state
    }
  };

  return (
    <form className="login-form" onSubmit={handleSubmit}>
      <h2 className="form-title">{forgotPassword ? "Enter Your Email" : "Login"}</h2>
      {error && <Alert severity="error">{error}</Alert>}
      {!forgotPassword ? (
        <>
          <WhiteInputField
            className="custom-text-field"
            label="Email or Username"
            name="identifier"
            value={formData.identifier}
            onChange={handleChange}
            required
          />
          <WhiteInputField
            className="custom-text-field"
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <Button
            onClick={() => setForgotPassword(true)}
            className="forgot-password-button"
          >
            Forgot Password?
          </Button>
          <Button
            type="submit"
            className="submit-button primary-button"
            disabled={loading} // Disable button during loading
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Login"}
          </Button>
        </>
      ) : (
        <>
          <WhiteInputField
            className="custom-text-field"
            label="Enter your email"
            value={resetEmail}
            onChange={(e) => setResetEmail(e.target.value)}
            required
          />
          <Button
            onClick={handleForgotPassword}
            className="submit-button"
            disabled={loading} // Disable button during loading
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "Send Reset Email"}
          </Button>
          <Button
            onClick={() => setForgotPassword(false)}
            className="white-text-button"
          >
            Back to Login
          </Button>
        </>
      )}
    </form>
  );
};

export default LoginForm;
